import { render } from "./TimeScale.vue?vue&type=template&id=8a36ed7c&scoped=true"
import script from "./TimeScale.vue?vue&type=script&lang=js"
export * from "./TimeScale.vue?vue&type=script&lang=js"

import "./TimeScale.vue?vue&type=style&index=0&id=8a36ed7c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a36ed7c"]])

export default __exports__